<template>
  <div class="container-fluid">
    <div class="row mt-4">
      <div class="col-12">
        <h6>Calendario</h6>
      </div>
    </div>

    <div class="row mt-2">
      <div class="col-12 d-none d-md-block">
        <div class="card calendar-card">
          <FullCalendar :options="calendarOptions">
            <template v-slot:eventContent="arg">
              <div class="fc-event-wrapper" @mouseenter="showEventCard(arg.event, $event)" @mouseleave="hideEventCard">
                <div class="fc-event-content">
                  <span class="event-time">{{ formatTime(arg.timeText) }}</span>
                  <span class="event-title">{{ arg.event.title }}</span>
                </div>
              </div>
            </template>
          </FullCalendar>
        </div>
      </div>

      <!-- Vista de Eventos (Móvil) -->
      <div class="col-12 d-block d-md-none">
        <div v-if="sortedEvents.length > 0">
          <div v-for="(event, index) in sortedEvents" :key="index" class="event-item mb-3">
            <div class="d-flex justify-content-between align-items-center">
              <div>
                <p class="event-time mb-1">{{ formatTime(event.time) }}</p>
                <p class="event-title mb-0">{{ event.title }}</p>
              </div>
              <a :href="event.url" target="_blank" class="btn btn-sm session-btn" :class="event.tipo || 'meet'">
                <i :class="event.tipo === 'zoom' ? 'bi bi-camera-video' : 'bi bi-google'"></i>
              </a>
            </div>
          </div>
        </div>
        <div v-else>
          <p>No hay actividades para mostrar.</p>
        </div>
      </div>
    </div>
  </div>

  <div v-if="activeEventCard" class="event-card" :style="{
    top: eventCardPosition.y + 'px',
    left: eventCardPosition.x + 'px',
  }" @mouseenter="keepCardVisible = true" @mouseleave="hideEventCard">
    <div class="card-content">
      <p class="card-time">{{ formatTime(activeEventCard.time) }}</p>
      <p class="card-title">{{ activeEventCard.title }}</p>
      <a :href="activeEventCard.url" target="_blank" class="btn btn-sm card-btn"
        :class="activeEventCard.tipo || 'meet'">
        <i :class="activeEventCard.tipo === 'zoom' ? 'bi bi-camera-video' : 'bi bi-google'"></i>
      </a>
    </div>
  </div>
</template>

<script>
import esLocale from "@fullcalendar/core/locales/es";
import FullCalendar from "@fullcalendar/vue3";
import dayGridPlugin from "@fullcalendar/daygrid";
import SesionService from "../../services/SesionService";

export default {
  data() {
    return {
      user: JSON.parse(localStorage.getItem("user")),
      loading: false,
      activeEventCard: null,
      keepCardVisible: false,
      eventCardPosition: { x: 0, y: 0 },
      calendarOptions: {
        plugins: [dayGridPlugin],
        initialView: "dayGridMonth",
        weekends: true,
        events: [],
        locale: esLocale,
        eventClick: this.eventClick,
        eventDisplay: 'auto',
        eventTimeFormat: {
          hour: '2-digit',
          minute: '2-digit',
          hour12: true
        },
      },
      sortedEvents: [],
    };
  },
  mounted() {
    this.cargarCalendario();
  },
  components: {
    FullCalendar,
  },
  methods: {
    eventClick(args) {
      args.jsEvent.preventDefault();
      window.open(args.event.url, "_blank");
    },
    openEvent(event) {
      window.open(event.url, "_blank");
    },
    cargarCalendario() {
      this.loading = true;

      SesionService.getObtenerSesionesPorUsuario(this.user.id)
        .then((response) => {
          const arrayEvents = response.data.data;
          let calendarEvents = [];
          let eventsList = [];

          arrayEvents.forEach((e) => {
            const eventDate = new Date(e.fecha + " " + e.hora_inicio);
            const currentDate = new Date();

            if (eventDate >= currentDate) {
              const eventObj = {
                title: e.nombre,
                date: e.fecha,
                time: e.hora_inicio,
                url: e.enlace,
                tipo: e.tipo
              };

              calendarEvents.push({
                ...eventObj,
                start: e.fecha + "T" + e.hora_inicio,
                backgroundColor: this.getEventColor(e.tipo),
                borderColor: this.getEventColor(e.tipo),
                textColor: '#ffffff'
              });

              eventsList.push(eventObj);
            }
          });

          this.calendarOptions.events = calendarEvents;
          this.sortedEvents = eventsList.sort(
            (a, b) => new Date(a.date) - new Date(b.date)
          );

          this.loading = false;
        })
        .catch((error) => {
          console.error("Error al obtener sesiones:", error);
          this.loading = false;
        });
    },
    getEventColor(tipo) {
      return tipo === 'zoom' ? '#2D8CFF' : '#00AC47';
    },
    formatTime(time) {
      if (typeof time !== "string") {
        console.error("Time is not a string:", time);
        return time;
      }

      const timePart = time.includes("T")
        ? time.split("T")[1].substring(0, 5)
        : time.substring(0, 5);

      const [hour, minute] = timePart.split(":");
      const ampm = +hour >= 12 ? "PM" : "AM";
      const hour12 = +hour % 12 || 12;
      return `${hour12}:${minute} ${ampm}`;
    },
    showEventCard(event, mouseEvent) {
      this.activeEventCard = {
        title: event.title,
        time: event.startStr.split('T')[1],
        url: event.url,
        tipo: event.extendedProps.tipo
      };
      this.eventCardPosition = {
        x: mouseEvent.pageX + 10,
        y: mouseEvent.pageY + 10
      };
      this.keepCardVisible = true;
    },
    hideEventCard() {
      this.keepCardVisible = false;
      setTimeout(() => {
        if (!this.keepCardVisible) {
          this.activeEventCard = null;
        }
      }, 200);
    }
  },
};
</script>

<style scoped>
.calendar-card {
  padding: 10px;
  margin: 0 auto;
  border-radius: 8px;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.1);
  border: none;
}

@media (min-width: 768px) {
  .calendar-card {
    width: 100%;
  }
}

:deep(.fc-event) {
  border: none;
  padding: 2px 4px;
  margin: 1px 0;
  cursor: pointer;
}

.fc-event-wrapper {
  height: 100%;
}

.fc-event-content {
  display: flex;
  flex-direction: column;
}

.event-time {
  font-size: 10px;
  font-weight: bold;
  line-height: 1.2;
}

.event-title {
  font-size: 11px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  line-height: 1.2;
}

.event-card {
  position: absolute;
  z-index: 1000;
  width: 160px;
  background: white;
  border-radius: 6px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
  padding: 10px;
  pointer-events: auto;
  animation: fadeIn 0.15s ease-out;
}

@keyframes fadeIn {
  from {
    opacity: 0;
    transform: translateY(5px);
  }

  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.card-content {
  display: flex;
  flex-direction: column;
}

.card-time {
  font-size: 11px;
  color: #666;
  margin-bottom: 4px;
}

.card-title {
  font-size: 13px;
  font-weight: 500;
  margin-bottom: 8px;
}

.card-btn {
  align-self: flex-end;
  padding: 2px 8px;
  font-size: 11px;
}

.card-btn.zoom {
  background-color: #2D8CFF;
  color: white;
}

.card-btn.meet {
  background-color: #00AC47;
  color: white;
}

.event-item {
  background-color: #fff;
  border-radius: 8px;
  padding: 12px;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.05);
}

.event-time {
  font-size: 12px;
  color: #666;
}

.event-title {
  font-size: 14px;
  font-weight: 500;
}

.session-btn {
  min-width: 32px;
  padding: 4px 8px;
}

.session-btn.zoom {
  background-color: #2D8CFF;
  color: white;
}

.session-btn.meet {
  background-color: #00AC47;
  color: white;
}

:deep(.fc-header-toolbar) {
  margin-bottom: 10px;
}

:deep(.fc-toolbar-title) {
  font-size: 1.2rem;
}

:deep(.fc-day-header) {
  font-size: 0.8rem;
  font-weight: 500;
  padding: 5px 0;
}
</style>